import ViewManager from "../../core/src/utils/ViewManager";
import CommManager from "../../core/src/controllers/CommManager";
import BetModel from "../../core/src/model/BetModel";
import GameModel from "../../core/src/model/GameModel";
import requestRegister from "../../core/src/server/requests/RequestRegister";
import { State } from "../../core/src/states/State";
import UIController from "../../core/src/ui/UIController";
import { UIModes, UIStates } from "../../core/src/ui/UIStates";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import KeyboardManager, { Key } from "../../core/src/utils/KeyboardManager";
import SpinModel from "../../core/src/model/SpinModel";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from '../../core/src/commands/CommandEnum';
import { DefaultLayers } from "../../core/src/utils/Layers";
import ReelGroup from "../../core/src/views/ReelGroup";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import RealityCheckModel from "../../core/src/model/RealityCheckModel";
import { Tween } from "../../core/src/Tween";
import { UIUpdateEvent } from "../../core/src/ui/UIUpdateEvents";
import VendorModel from "../model/VendorModel";
import ConsoleUtil from "../../core/src/utils/ConsoleUtil";
import App from "../../core/src/App";

export default class Idle extends State {
    protected balanceIntervalID: any;
    protected balanceRequestSent = false;
    protected realityCheckTimer;
    protected autoSpinDelayCall: Tween = null;

    public enter(): void {
        super.enter();

        this.makeBalanceRequest();
    }

    protected makeBalanceRequest() {
        if (GameModel.shouldUpdateBalance) {
            CommManager.send(
                RequestRegister.get("getBalance"),
                (data) => {
                    GameModel.shouldUpdateBalance = false;
                    BetModel.balance = data.b;
                    // Ensure we are STILL on this state, when the response comes in.
                    if (this.stateMachine.currentState == this) {
                        this.applyStateSettings();
                    }
                },
                this
            );
        } else {
            this.applyStateSettings();
        }
        
    }

    protected applyStateSettings() {
        if (AutoplayModel.isAutoSpinActive() && !GameModel.shouldPauseGame) {
            this.autoSpinDelayCall = Tween.delayedCall(App.config.autoSpinDelay || 0.1, () => {
                this.spinIfInAutoplay();
            })
        }

        GameModel.restoreData = null;
       // UIController.updateFields(UIUpdateEvent.All);
        
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();

        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        if(VendorModel.allowSwipeSpin) {
            reelGroup.enableSwipeSpin();
        } else {
            reelGroup.disableSwipeSpin();
        }

        UIController.setMode(UIModes.DEFAULT);
        UIController.setState(UIStates.IDLE);

        if (GameModel.shouldPauseGame) {
            UIController.setState(UIStates.SPIN);
            this.cleanDelayCall();
        }

        if (GameModel.hasRealityCheck) {
            let timeLeft = RealityCheckModel.getTimeTillTimeLimit();

            ConsoleUtil.log("[IdleState] Reality check time left: " + timeLeft);

            if (timeLeft > 0) {
                this.realityCheckTimer = setTimeout(
                    this.forceRealityCheck.bind(this),
                    timeLeft
                );
            } else {
                this.forceRealityCheck();
            }
        }

        if (AutoplayModel.isAutoSpinActive()) {
            if (GameModel.shouldStopAutoplay) {
                GameModel.shouldStopAutoplay = false;
                AutoplayModel.setAutoSpin(0);
                this.cleanDelayCall();
            }
            if (AutoplayModel.autoSpinLimitReached) {
                UIController.toggleComponent("autoplayLimitPopup");
                CommandManager.execute(Commands.STOP_AUTOPLAY);
                CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS);
            } else {
                UIController.setMode(UIModes.AUTO);
                UIController.setState(UIStates.IDLE);
                return;
            }
        }
        
        KeyboardManager.onKey("pressed", Key.SPACE, this.spinWithKey, this);
    }

    protected forceRealityCheck() {
        GameModel.forceRealityCheck = true;
        this.exit();
        return;
    }

    protected spinWithKey() {
        if (GameModel.spaceToSpin) {
            CommandManager.execute(Commands.SPIN);
        }
    }

    public exit(): void {
        if (GameModel.spaceToSpin) {
            KeyboardManager.offKey("pressed", Key.SPACE, this.spinWithKey, this);
        }

        if (this.realityCheckTimer) {
            clearTimeout(this.realityCheckTimer);
            this.realityCheckTimer = null;
        }
        
        clearInterval(this.balanceIntervalID);
        this.balanceRequestSent = false;
        SpinModel.exitRespins();
        super.exit();
    }

    public canExit(): boolean {
        return true;
    }

    protected updateBalance() {
        if (this.balanceRequestSent) {
            return;
        }
        CommManager.send(
            requestRegister.get("balanceRequest"),
            function (data: any) {
                this.onBalanceRecieved(data.data);
            },
            this
        );
    }

    protected onBalanceRecieved(data) {
        this.balanceRequestSent = false;
        BetModel.balance = data.balance;
    }

    protected startBalanceCounter() {
        this.balanceIntervalID = setInterval(
            this.updateBalance.bind(this),
            5000
        );
    }

    protected setUIState(activateSpinBtnDelay: number): void {
        // Commented out in order to fix https://awd-group.atlassian.net/browse/VOL-116 (Bet can be changed during spin)
        // if (activateSpinBtnDelay <= 0) {
        //     UIController.setState(UIStates.IDLE);
        // } else {
        //     KeyboardManager.disable()
        //     Tween.delayedCall(activateSpinBtnDelay, () => {
        //         UIController.setState(UIStates.IDLE);
        //         KeyboardManager.enable();
        //     });
        // }
    }


    protected spinIfInAutoplay(): void {
        if (AutoplayModel.isAutoSpinActive()) {
            if (!GameModel.shouldStopAutoplay) {
                CommandManager.execute(Commands.SPIN);
            }
        }
    }

    protected cleanDelayCall() {
        if (this.autoSpinDelayCall) {
            this.autoSpinDelayCall.kill();
            this.autoSpinDelayCall = null;
        }
    }
}
